import { dollarsToSatoshis } from "../../utils";
import { productPricingRowFromService, productPricingRowToService } from "./shared";
/**
 * Converts service agency list item to UI format.
 * List items don't have billing info.
 * @param item - Service agency pricing list item
 * @returns UI-formatted agency (no billingInfo)
 */
export const pricingAgencyFromService = (item) => {
    return {
        id: item.id,
        name: item.name,
        advertiserCount: item.advertiser_count,
        productsPriced: item.products_priced,
        productsTotal: item.products_total
    };
};
/**
 * Converts service agency detail to UI format.
 * Unflattens: service flat structure → UI nested billingInfo.
 * The detail lists every product the org can see, so the priced and total
 * counts are derived from it.
 * @param agency - Service agency billing info (flat)
 * @returns UI-formatted agency with nested billingInfo
 */
export const pricingAgencyBillingInfoFromService = (agency) => {
    const products = agency.products?.map(productPricingRowFromService);
    return {
        id: agency.agency_id,
        name: agency.name,
        advertiserCount: agency.advertiser_count,
        productsPriced: products?.filter((p) => p.cpm != null).length ?? 0,
        productsTotal: products?.length ?? 0,
        billingInfo: {
            products
        }
    };
};
/**
 * Converts UI agency to service format.
 * Flattens: UI nested billingInfo → service flat structure.
 * @param agency - UI agency with nested billingInfo
 * @returns Service-formatted agency (flat)
 */
export const pricingAgencyBillingInfoToService = (agency) => {
    return {
        agency_id: agency.id,
        name: agency.name,
        advertiser_count: agency.advertiserCount,
        products: agency.billingInfo?.products?.map(productPricingRowToService)
    };
};
/**
 * Converts agency to service upsert agency CPM request.
 * Expects billingInfo.products to hold only the changed rows; a row without a
 * cpm is sent as 0, which deletes the agency rate.
 * @param agency - Agency with the changed product rows
 * @returns Service-formatted upsert request
 */
export const upsertAgencyCpmRequestToService = (agency) => {
    const products = agency.billingInfo?.products ?? [];
    return {
        upserts: products
            .filter((p) => !!p.id)
            .map((p) => ({
            prod_id: p.id,
            agency_id: agency.id,
            cpm: dollarsToSatoshis(p.cpm)
        }))
    };
};
//# sourceMappingURL=agencies.js.map